import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, MbsPopupType, ModalFooterDirective } from 'mbs-ui-kit';
import { ModalComponent } from 'mbs-ui-kit/modal/modal.component';

@Component({
  selector: 'remote-connection-required-permissions-modal',
  templateUrl: './remote-connection-required-permissions-modal.component.html',
  standalone: true,
  imports: [CommonModule, ButtonComponent, AlertComponent, I18NextPipe, ModalComponent, ModalFooterDirective]
})
export class RemoteConnectionRequiredPermissionsModalComponent {
  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;
  public readonly alertType = MbsPopupType;
}
